import clsx from 'clsx'
import React from 'react'

const roundedStyles = 'first:rounded-t-lg last:rounded-b-lg'

type CardProps = {
  children?: React.ReactNode
  className?: string
}
export function Card({ children, className, ...props }: CardProps) {
  return (
    <section className={className} {...props}>
      {children}
    </section>
  )
}

type CardHeaderProps = {
  children?: React.ReactNode
  className?: string
}
export function CardHeader({ children, className }: CardHeaderProps) {
  return (
    <header
      className={clsx(
        'p-6 bg-surface-selected-default rounded-t-lg items-center',
        roundedStyles,
        className
      )}
    >
      {children}
    </header>
  )
}

type CardBodyProps = {
  children?: React.ReactNode
  className?: string
}
export function CardBody({ children, className }: CardBodyProps) {
  return (
    <div className={clsx('bg-white', roundedStyles, className)}>{children}</div>
  )
}

type CardFooterProps = {
  children?: React.ReactNode
  className?: string
}
export function CardFooter({ children, className }: CardFooterProps) {
  return (
    <footer
      className={clsx(
        'bg-white flex p-5 border-t border-subdued',
        roundedStyles,
        className
      )}
    >
      {children}
    </footer>
  )
}
